/**
 * BudgetAlertService
 * Fired budget alerts: filtered list + acknowledge.
 * Route: api/budget-alerts
 */
export class BudgetAlertService {
    constructor(http, config) {
        this.http = http;
        const servicePath = config?.servicePath ?? BudgetAlertService.DEFAULT_SERVICE_PATH;
        this.basePath = `${servicePath}/${BudgetAlertService.BASE_PATH}`;
    }
    buildUrl(path) {
        const url = path ? `${this.basePath}/${path}` : this.basePath;
        return url.startsWith('/') ? url : '/' + url;
    }
    /** Alerts, optionally filtered by budget and/or acknowledged state
     * (enriched views — wire-compatible superset of the raw entity shape). */
    async getFiltered(filter) {
        const params = new URLSearchParams();
        if (filter?.budgetId !== undefined)
            params.append('budgetId', String(filter.budgetId));
        if (filter?.acknowledged !== undefined)
            params.append('acknowledged', String(filter.acknowledged));
        const qs = params.toString();
        const url = this.buildUrl();
        const response = await this.http.get(qs ? `${url}?${qs}` : url);
        return response.data ?? [];
    }
    /** Acknowledge an alert (does NOT re-arm the threshold). */
    async acknowledge(id) {
        const response = await this.http.put(this.buildUrl(`${id}/acknowledge`), {});
        if (!response.data)
            throw new Error(`Failed to acknowledge alert ${id}`);
        return response.data;
    }
}
BudgetAlertService.DEFAULT_SERVICE_PATH = 'budgets';
BudgetAlertService.BASE_PATH = 'api/budget-alerts';
//# sourceMappingURL=BudgetAlertService.js.map